import './DashedPlusButton.css';

import React from 'react';

export interface DashedPlusButtonProps {
  onClick: () => void;
  disabled?: boolean;
  /** Accessible name (e.g. "Add team"). */
  ariaLabel?: string;
  className?: string;
  /** Defaults to "+" */
  children?: React.ReactNode;
}

const DashedPlusButton: React.FC<DashedPlusButtonProps> = ({
  onClick,
  disabled = false,
  ariaLabel = 'Add',
  className = '',
  children = '+',
}) => (
  <button
    type="button"
    className={`dashed-plus-button ${className}`.trim()}
    disabled={disabled}
    onClick={onClick}
    aria-label={ariaLabel}
  >
    {children}
  </button>
);

export default DashedPlusButton;
